// Tiny relative-time formatter. Pure function so it's easy to test and
// reuse anywhere a backend timestamp needs to render as "2m ago".
//
// Buckets: <60s "just now", <60m "Nm ago", <24h "Nh ago",
//          <7d "Nd ago", else short ISO date (YYYY-MM-DD).

export function formatRelative(input: string | Date, now: Date = new Date()): string {
  const t = typeof input === "string" ? new Date(input) : input;
  if (isNaN(t.getTime())) return "";
  const deltaMs = now.getTime() - t.getTime();
  if (deltaMs < 0) return "just now";

  const sec = Math.floor(deltaMs / 1000);
  if (sec < 45) return "just now";

  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;

  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;

  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;

  // Fall back to ISO date (no time) for anything older than a week.
  return t.toISOString().slice(0, 10);
}
